import { render } from "./CommunicationsForm.vue?vue&type=template&id=a2f7ae58"
import script from "./CommunicationsForm.vue?vue&type=script&lang=js"
export * from "./CommunicationsForm.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/moncasan_app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__